// /opt/isp_erp/frontend/src/components/warehouse/materiales/utils.jsx
import React, { useState, useEffect } from 'react';
import {
  Paper, Typography, TextField, InputAdornment, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import { Search } from '@mui/icons-material';

export const pad = (n) => String(n).padStart(2, '0');
export const fechaLocal = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const fmtNum = (n) => {
  const x = Number(n || 0);
  return Number.isInteger(x) ? String(x) : x.toFixed(2);
};
export const fechaHora = (v) => (v ? new Date(v).toLocaleString('es-EC', {
  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
}) : '—');

export const detalleError = (err, porDefecto) => {
  const d = err.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join('; ');
  return porDefecto;
};

export const TIPOS_MATERIAL = ['FIBRA', 'CONECTOR', 'CAJA', 'SPLITTER', 'OTRO'];
export const colorTipo = (tipo) => ({
  FIBRA: 'primary', CONECTOR: 'secondary', CAJA: 'success', SPLITTER: 'warning', OTRO: 'default'
}[tipo] || 'default');

export const recorte = {
  display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', maxWidth: 260
};

export const useDebouncedValue = (valor, ms = 400) => {
  const [v, setV] = useState(valor);
  useEffect(() => {
    const t = setTimeout(() => setV(valor), ms);
    return () => clearTimeout(t);
  }, [valor, ms]);
  return v;
};

export const Kpi = ({ titulo, valor, detalle, color }) => (
  <Paper
    variant="outlined"
    sx={{ p: 2, width: '100%', minHeight: 96, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
  >
    <Typography variant="caption" color="text.secondary">{titulo}</Typography>
    <Typography variant="h5" fontWeight="bold" color={color || 'inherit'}>{valor}</Typography>
    <Typography variant="caption" color="text.secondary">{detalle || '\u00A0'}</Typography>
  </Paper>
);

export const CampoBusqueda = ({ value, onChange, label }) => (
  <TextField
    fullWidth
    size="small"
    label={label}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Search fontSize="small" />
        </InputAdornment>
      )
    }}
  />
);

export const SelectProveedor = ({ value, onChange, proveedores }) => (
  <FormControl fullWidth size="small">
    <InputLabel>Proveedor</InputLabel>
    <Select label="Proveedor" value={value} onChange={onChange}>
      <MenuItem value="">Todos</MenuItem>
      {(proveedores || []).map((p) => (
        <MenuItem key={p.id} value={p.id}>{p.nombre}</MenuItem>
      ))}
    </Select>
  </FormControl>
);
